//@service
import {
  bind,
  RepositoryInterface
} from '@/service/utils'
export const interviewService = {
  get interviewRepository() {
    return bind(() => import('./interview.repo'), RepositoryInterface);
  },
  get questionSuggestRepository() {
    return bind(() => import('./questionSuggest.repo'), RepositoryInterface);
  },
  get questionSuggestEvaluationRepository() {
    return bind(() => import('./questionSuggestEvaluation.repo'), RepositoryInterface);
  },
  get interviewKhelpRepository() {
    return bind(() => import('./interviewKhelp.repo'), RepositoryInterface);
  },
  get interviewMhelpRepository() {
    return bind(() => import('./interviewMhelp.repo'), RepositoryInterface);
  },
  get interviewPhelpRepository() {
    return bind(() => import('./interviewPhelp.repo'), RepositoryInterface);
  },
  get interviewVhelpRepository() {
    return bind(() => import('./interviewVhelp.repo'), RepositoryInterface);
  },
  get interviewLocationRepository() {
    return bind(() => import('./interviewLocation.repo'), RepositoryInterface);
  },
  get interviewLocationPlanRepository() {
    return bind(() => import('./interviewLocationPlan.repo'), RepositoryInterface);
  },
  get interviewDoingRepository() {
    return bind(() => import('./interviewDoing.repo'), RepositoryInterface);
  },
  get interviewLocationPersonRepository() {
    return bind(() => import('./interviewLocationPerson.repo'), RepositoryInterface);
  },
  get interviewLocationAudiencesRepository() {
    return bind(() => import('./interviewLocationAudiences.repo'), RepositoryInterface);
  },
    get interviewAzmoonExecutePersonRepository() {
    return bind(() => import('./interviewAzmoonExecutePerson.repo'), RepositoryInterface);
  },
}
